import moment from 'moment';
import { orderBy } from 'lodash';

export const buildTransmissionHistoryLogs = historyLogs => historyLogs.map(({ log: { data } }) => buildTransmission(data))

export const buildTransmission = transmission => {

    if (!transmission.vehicle) {
        transmission.vehicle = {};
    }

    if (!transmission.event) {
        transmission.event = {};
    }

    if (
        transmission.event &&
        transmission.event.location &&
        transmission.event.location.coordinates &&
        Array.isArray(transmission.event.location.coordinates)
    ) {
        // Convert from Geocode to GeoJSON
        transmission.event.location.coordinates = transmission.event.location.coordinates.reverse();
    }


    return {
        ...transmission,
        event: {
            ...transmission.event,
            date_last_data: transmission.event.timestamp 
                ? moment(transmission.event.timestamp).format('DD/MM/YYYY HH:mm')
                : moment(transmission.timestamp || new Date()).format('DD/MM/YYYY HH:mm'),
            event_value: transmission.event.event_value || transmission.event_value || ''
        },
        vehicle: {
            ...transmission.vehicle,
            plate: transmission.vehicle.plate || '',
            updated: transmission.vehicle.updated
                ? moment(transmission.vehicle.updated).format('DD/MM/YYYY HH:mm')
                : ''
        }
    };
};

export const sortTransmission = transmissions =>
    orderBy(transmissions, transmission => {
     
        return transmission.event?.timestamp || 
               transmission.timestamp || 
               transmission.created || 
               new Date().toISOString();
    }, 'desc');
